import {
	PARAGRAPH_KEY,
	HEADING_KEY,
} from '@techchange/pm-specs';
import { keymap } from 'prosemirror-keymap';

import { toggleHeading } from '../commands';

const headingKeymap = keymap({
	'Mod-Alt-0': toggleHeading(PARAGRAPH_KEY),
	'Mod-Alt-1': toggleHeading(HEADING_KEY, { level: 1 }),
	'Mod-Alt-2': toggleHeading(HEADING_KEY, { level: 2 }),
	'Mod-Alt-3': toggleHeading(HEADING_KEY, { level: 3 }),
});

export default headingKeymap;
